import { useMemo, useState } from "react";
import { debounce } from "lodash";

import { inputDebounceDelay } from "hooks/constants";
import {
  getShipmentCityOptions,
  HistoricalShipmentCitiesUrl,
  useSearchHistoricalShipmentCities,
} from "hooks/useSearchHistoricalShipmentCities";
import FilterMultiSelect from "./FilterMultiSelect";

export type HistoricalShipmentCitySelectProps = {
  name: string;
  label: string;
  ariaLabel: string;
  citiesUrl: HistoricalShipmentCitiesUrl;
  countryCodes: string[];
  searchMinLength: number | null;
  value: string[];
  onChange: (value: string[]) => void;
};

const HistoricalShipmentCitySelect = ({
  citiesUrl,
  countryCodes,
  searchMinLength,
  value,
  ...filterProps
}: HistoricalShipmentCitySelectProps) => {
  const [search, setSearch] = useState("");
  const { data: cities, isLoading } = useSearchHistoricalShipmentCities(
    citiesUrl,
    search,
    countryCodes,
    searchMinLength
  );

  const debouncedSetSearch = useMemo(
    () => debounce(setSearch, inputDebounceDelay),
    []
  );

  const cityOptions = useMemo(
    () => getShipmentCityOptions(cities, value),
    [cities, value]
  );

  return (
    <FilterMultiSelect
      {...filterProps}
      placeholder="Type to search"
      search
      deburr
      disabled={searchMinLength === null}
      minCharacters={searchMinLength ?? undefined}
      options={cityOptions}
      loading={isLoading}
      value={value}
      onSearchChange={(_event, { searchQuery }) =>
        debouncedSetSearch(searchQuery.trim())
      }
    />
  );
};

export default HistoricalShipmentCitySelect;
